import request from "root/js/request";

export const getAdvertWidgets = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  advert_id__in,
  brand_id__in,
  category_id__in,
  subject_id__in,
  product_id__in,
  type__in,
  status__in,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/advert_widgets/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      advert_id__in,
      brand_id__in,
      category_id__in,
      subject_id__in,
      product_id__in,
      type__in,
      status__in,
      ...rest,
    },
  });
  return response.data;
};
